import type { Logger } from "@scripts/bondlink";

export const exhaustive = (log: Logger) => (a: never): never => {
  log.fatal("Exhaustive Match Reached:", a);
  return a;
};

export const exhaustiveNoLog = (a: never): never => a;
